import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-sign-up" }
const _hoisted_3 = { class: "s10_mobile container-full-2" }
const _hoisted_4 = { class: "form-field-floating lg reactive active my-5" }
const _hoisted_5 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_6 = { class: "form-field-split my-5" }
const _hoisted_7 = { class: "form-field-floating lg reactive half" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-field-floating lg reactive half" }
const _hoisted_10 = { class: "form-field-split my-5" }
const _hoisted_11 = { class: "form-field-floating lg reactive half" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-field-floating lg reactive half" }
const _hoisted_14 = { class: "form-field-floating full lg my-5" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "s10_mobile container-full-2" }
const _hoisted_17 = { class: "form-field-floating xl reactive active my-5" }
const _hoisted_18 = { class: "form-field-split active my-5" }
const _hoisted_19 = { class: "form-field-floating xl reactive half" }
const _hoisted_20 = { class: "form-field-floating xl reactive half" }
const _hoisted_21 = { class: "form-field-floating full lg my-5" }
const _hoisted_22 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomPhoneInput = _resolveComponent("CustomPhoneInput")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "s20 form",
        onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _cache[40] || (_cache[40] = _createElementVNode("a", { href: "#" }, [
          _createElementVNode("div", { class: "text-center mb-8" }, [
            _createElementVNode("img", {
              src: "/public/images/logo-wide.svg",
              class: "auth-logo2"
            })
          ])
        ], -1)),
        _cache[41] || (_cache[41] = _createElementVNode("h2", { class: "font-semibold mt-5 mb-4 text-center" }, "Créer votre compte", -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[27] || (_cache[27] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-info-perso.svg",
              class: "size-l",
              alt: ""
            }),
            _createTextVNode(" Informations personnelles ")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              name: "nom",
              id: "nom",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.nom) = $event)),
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.nom]
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "nom" }, [
              _createTextVNode("Nom "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              name: "prenom",
              id: "prenom",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.prenom) = $event)),
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.prenom]
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "prenom" }, [
              _createTextVNode("Prénoms "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("input", {
                type: "date",
                class: "form-input",
                name: "date_naissance",
                id: "date_naissance",
                value: _ctx.formData.dateNaissance,
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDateNaissanceChange && _ctx.onDateNaissanceChange(...args))),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDateNaissanceChange && _ctx.onDateNaissanceChange(...args))),
                placeholder: ""
              }, null, 40, _hoisted_8),
              _cache[19] || (_cache[19] = _createElementVNode("label", { for: "date_naissance" }, [
                _createTextVNode("Date de naissance "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "hr" }, null, -1)),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "age",
                id: "age",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.age) = $event)),
                readonly: "",
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.age]
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("label", { for: "age" }, [
                _createTextVNode("Age "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("input", {
                type: "date",
                class: "form-input",
                name: "date_engagement",
                id: "date_engagement",
                value: _ctx.formData.dateEngagement,
                onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDateEngagementChange && _ctx.onDateEngagementChange(...args))),
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onDateEngagementChange && _ctx.onDateEngagementChange(...args))),
                placeholder: ""
              }, null, 40, _hoisted_12),
              _cache[22] || (_cache[22] = _createElementVNode("label", { for: "date_engagement" }, [
                _createTextVNode("Date d'engagement "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "hr" }, null, -1)),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "anciennete",
                id: "anciennete",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.anciennete) = $event)),
                readonly: "",
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.anciennete]
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("label", { for: "anciennete" }, [
                _createTextVNode("Ancienneté "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("select", {
              class: "form-input-select",
              name: "collectivite",
              id: "collectivite",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.collectivite) = $event))
            }, [
              _cache[25] || (_cache[25] = _createElementVNode("option", { value: "" }, "Sélectionnez votre collectivité", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectivites, (collectivite) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: collectivite.id,
                  value: collectivite.id
                }, _toDisplayString(collectivite.nom), 9, _hoisted_15))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.formData.collectivite]
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("label", { for: "collectivite" }, [
              _createTextVNode("Votre collectivité "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "h-20 show-mobile" }, null, -1)),
          _cache[39] || (_cache[39] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-engagement.svg",
              class: "size-l",
              alt: ""
            }),
            _createTextVNode(" Engagement ")
          ], -1)),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              name: "salaire_brut",
              id: "salaire_brut",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.salaireBrut) = $event)),
              onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.calculateQuotiteCessible && _ctx.calculateQuotiteCessible(...args))),
              placeholder: ""
            }, null, 544), [
              [_vModelText, _ctx.formData.salaireBrut]
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("label", { for: "salaire_brut" }, [
              _createTextVNode("Salaire brut "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1)),
            _cache[29] || (_cache[29] = _createElementVNode("span", null, "F CFA", -1))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "quotite_cessible",
                id: "quotite_cessible",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.quotiteCessible) = $event)),
                onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.calculateQuotiteCessibleValue && _ctx.calculateQuotiteCessibleValue(...args))),
                placeholder: ""
              }, null, 544), [
                [_vModelText, _ctx.formData.quotiteCessible]
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("label", { for: "quotite_cessible" }, [
                _createTextVNode("Quotité cessible max "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1)),
              _cache[31] || (_cache[31] = _createElementVNode("span", { class: "" }, "%", -1))
            ]),
            _cache[34] || (_cache[34] = _createElementVNode("hr", { class: "hr" }, null, -1)),
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "quotite_cessible_val",
                id: "quotite_cessible_val",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.quotiteCessibleVal) = $event)),
                readonly: "",
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.quotiteCessibleVal]
              ]),
              _cache[32] || (_cache[32] = _createElementVNode("label", { for: "quotite_cessible_val" }, [
                _createTextVNode("Valeur "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1)),
              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "" }, "F CFA", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_CustomPhoneInput, {
              modelValue: _ctx.formData.telephone,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.telephone) = $event)),
              "input-id": "telephone",
              label: "Numéro de téléphone"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "form-input",
              name: "email",
              id: "email",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.email) = $event)),
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.email]
            ]),
            _cache[35] || (_cache[35] = _createElementVNode("label", { for: "email" }, [
              _createTextVNode("Adresse Email "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "btn lg w-100 flex-center mt-8 mb-7",
            disabled: _ctx.isSubmitting
          }, [
            _cache[36] || (_cache[36] = _createElementVNode("img", {
              src: "/public/icons/icon-valider.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Envoi en cours...' : 'Continuer'), 1)
          ], 8, _hoisted_23),
          _createVNode(_component_router_link, { to: "/signin" }, {
            default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
              _createElementVNode("h5", { class: "text-primary-color text-center" }, "Vous avez déjà un compte ?", -1)
            ]))]),
            _: 1
          })
        ])
      ], 32)
    ])
  ]))
}